import {
    getLocaleLanguage,
} from './init';
import {
    trackWithDataAPI,
} from './api';

export default async function trackAndLog (p) {
    const {
        endpoint = 'ERROR-THROWN-ON-UI',
        traceString,
    } = p;
    const env = this.env;
    const apiKey = this.widgetSettings.apikey;
    if (this.isPreview) {
        return;
    }
    /*
    let locale = this.locale || 'en';
    if ( this.widget?.language && this.widget?.language !== 'auto') {
        locale = this.widget?.language;
    }
    */

    const locale = this.locale || getLocaleLanguage();
    await trackWithDataAPI({
        apiKey,
        widgetId: this.widget.id,
        traceId: `${env.traceId}-${traceString}` ,
        store: this,
        locale,
        body: {
            data: {
               app: this.widget,
            },
            api: {
                endpoint_url: endpoint,
            }
        }
    });
}
